import { render } from "./key-value-create.vue?vue&type=template&id=6624e770"
import script from "./key-value-create.vue?vue&type=script&lang=js"
export * from "./key-value-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__